import { assertAppIdMustUnique } from './assertions'

/**
 * @internal この定義を直接使うのではなく、AppIdモジュールを経由する想定
 */
export const hostAppIdMap = assertAppIdMustUnique({
  mycolor: 'MyColorWeb',
  ledian: 'MallLedianWeb',
  /**
   * ホスト名は hl となっているが、実際には美ラボ(vilb)で使用される.
   * 経緯は {@link https://github.com/my-color/front/issues/7343} の概要を参照.
   *
   * 内部的な扱いに閉じているのであれば vilb という名前に変更しても良かったが、実際には
   * {@link AppId.getHostName}経由で参照されるホスト名はassetsの探索などでも使われている = 外部とのやり取りで利用されている.
   * そのため、ホスト名を vilb に変更することはせず hl という名前を維持することにした.
   */
  hl: 'MallHOTELLOVERSWeb',
  /**
   * ホスト名・AppIdに2という連番がついている理由は
   * {@link https://github.com/my-color/front/issues/7343} の概要を参照.
   */
  hl2: 'MallHOTELLOVERSWeb2',
  fitowa: 'MallfitowaWeb',
})
export type HostAppIdMap = typeof hostAppIdMap
export type HostName = keyof HostAppIdMap
export type HostAppId = HostAppIdMap[HostName]

/**
 * @internal この定義を直接使うのではなく、AppIdモジュールを経由する想定
 */
export const brandAppIdMap = assertAppIdMustUnique({
  micoameri: 'MICOAMERIWeb',
  gadgetgirl: 'GadgetGirlWeb',
  michellmacaron: 'michellMacaronWeb',
  amiuuwink: 'AmiuuwinkWeb',
  rady: 'RadyWeb',
  regalect: 'RegalectWeb',
  missmine: 'missmineWeb',
  inframince: 'inframinceWeb',
  edna: 'ednaWeb',
  cherimi: 'cherimiWeb',
  solni: 'SOLNIWeb',
  honeymew: 'HONEYMEWWeb',
  /**
   * ブランド名は hl となっているが、実際には美ラボ(vilb)で使用される.
   * 経緯は https://github.com/my-color/front/issues/7343 の概要を参照.
   */
  hl: 'HOTELLOVERSWeb',
  /**
   * ホテラバ用であるにも関わらず2という連番を付与したブランド名になっている理由は
   * https://github.com/my-color/front/issues/7343 の概要を参照.
   */
  hl2: 'HOTELLOVERSWeb2',
  'off-tone': 'off-toneWeb',
  okashiya: 'okashiyaWeb',
  fitowa: 'fitowaWeb',
  ledian: 'LedianWeb',
})
export type BrandAppIdMap = typeof brandAppIdMap
export type BrandName = keyof BrandAppIdMap
export type BrandAppId = BrandAppIdMap[BrandName]
